export default "__VITE_ASSET__KEywep6y__"